import { convertThousandsSeparatorToRegExp } from './convertThousandsSeparatorToRegExp';

import type { ParseMoneyFunction, ParseLocalizedMoneyFunction } from './types';

/**
 * Parse given amount as float or return as is if already a float
 */
export const parseMoney: ParseMoneyFunction = (amount) => {
	if (typeof amount === 'number') return amount;
	const float = Number.parseFloat(amount);
	if (Number.isNaN(float)) return 0;
	return float;
};

/**
 * Curried function that removes localized formatting and returns a float
 */
export const parseLocalizedMoney: ParseLocalizedMoneyFunction =
	({ locale, decimalMark, thousandsSeparator }) =>
	(amount) => {
		let normalized = amount.toLocaleString(locale);
		// account for whitespace which needs different approach for scrubbing
		const regExp = convertThousandsSeparatorToRegExp(thousandsSeparator);
		if (regExp) {
			// remove thousands separators
			normalized = amount.toLocaleString(locale).replaceAll(regExp, '');
		}
		// Replace decimal mark with '.'
		if (decimalMark !== '.') {
			normalized = normalized.replace(decimalMark, '.');
		}
		return Number.parseFloat(normalized);
	};
